import {gql} from '@apollo/react-hooks'

const CreateGameMutation = gql(`
mutation createGame($isPrivate: Boolean! $questionSet: Int $dateStart: AWSDateTime $PlayerId: String  $PlayerDisplayName: String) {
        createGame( 
          IsPrivate: $isPrivate
          DateStart: $dateStart
          RoundCurrent: 0
          QuestionSet: $questionSet
          Player_1: $PlayerId
          Player_1_DisplayName : $PlayerDisplayName
          Player_1_Score : 0
          Player_1_Round : 0
          Player_2: ""
          Player_3: ""
          Player_4: ""
        ) {
          id
          IsPrivate
          RoundCurrent
          QuestionSet
          Player_1
          Player_2
          Player_3
          Player_4
        }
      }
    
`
);
export default CreateGameMutation